import React from 'react';
import {observer, inject} from 'mobx-react';
import {injectIntl} from 'react-intl';
import {FormGroup, Checkbox} from 'react-bootstrap';

@injectIntl @inject("rootStore") @observer
export default class NotificationsToolbar extends React.Component{

    render(){
        const {feedbackChain, intl} = this.props;
        let participation = feedbackChain.getParticipationByUser(this.props.rootStore.user);
        if( !participation ){
            participation = {webNotifications: false, mailNotifications: false};
        }
        return (
            <div className={'toolbar notifications'}>
                <div className={'title'}> <i className="glyphicon glyphicon-bell" />
                    {intl.formatMessage({id:"notifications"})}
                </div>
                <div className={'content'}>
                    <FormGroup>
                        <Checkbox
                            checked={participation.webNotifications == true}
                            readOnly={false}
                            onChange={(e) => this.handleNotificationsChange("webNotifications", e.target.checked)} >
                            {intl.formatMessage({id: "web_notifications"})}
                        </Checkbox>
                        <Checkbox
                            checked={participation.mailNotifications == true}
                            readOnly={false}
                            onChange={(e) => this.handleNotificationsChange("mailNotifications", e.target.checked)} >
                            {intl.formatMessage({id: "mail_notifications"})}
                        </Checkbox>
                    </FormGroup>
                </div>
            </div>
        );
    }

    handleNotificationsChange = (type, val) => {
        this.props.feedbackChain.updateNotifications(type, val);
    }
}